import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/logo-jsh.png'


const _withScopeId = n => (_pushScopeId("data-v-6fab27f9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "left-side" }
const _hoisted_2 = { class: "right-side" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "change-theme-btn" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 浅色模式 ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 深色模式 ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 跟随系统 ", -1))
const _hoisted_8 = { style: {"cursor":"pointer","color":"rgb(var(--gray-8))"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 配置中心 ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 退出 ", -1))

import { useDark, useToggle } from '@vueuse/core'
import { getRefreshToken, setRefreshToken, setToken } from '@/utils'
import { useLogout } from '@/hooks/use-logout'
import { ref } from 'vue'
import { install, listenCanInstall } from '@/install'
import { useAppStore, useUserStore } from '@/store'
import Menu from './menu.vue'
import { LoginRes } from '@/views/login/login.interface'
import { Api } from '@/apis'
import jwtDecode from 'jwt-decode'
import { UserState } from '@/store/modules/user/user.interface'
import * as Sentry from '@sentry/vue'
import { useHttp } from '@/plugins'
import { Notification } from '@arco-design/web-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'header-section',
  setup(__props) {

const { logout } = useLogout()
const user = useUserStore()
const app = useAppStore()
const http = useHttp()

const isDark = useDark({
  selector: 'body',
  attribute: 'arco-theme',
  valueDark: 'dark',
  valueLight: 'light',
  storageKey: 'app-theme'
})
const toggleTheme = useToggle(isDark)

const themeModel = ref(localStorage.getItem('theme-model') || 'auto')
function changeTheme (mode?: 'light'|'dark'|'auto') {
  let themeMedia
  switch (mode) {
    case 'light':
      if (isDark.value) toggleTheme()
      break
    case 'dark':
      if (!isDark.value) toggleTheme()
      break
    case 'auto':
      themeMedia = window.matchMedia('(prefers-color-scheme: light)')
      if (themeMedia.matches && isDark.value) toggleTheme()
      if (!themeMedia.matches && !isDark.value) toggleTheme()
      break
    default:
      toggleTheme()
  }
  const newMode = mode || (isDark.value ? 'dark' : 'light')
  themeModel.value = newMode
  localStorage.setItem('theme-model', newMode)
}

const canInstall = ref(false)
listenCanInstall((result) => {
  canInstall.value = result
})

function installApp () {
  install()
}

function updateAuth () {
  http.post<LoginRes>(Api.refreshToken, {
    refreshToken: getRefreshToken()
  }).then(res => {
    if (res.data.success) {
      const { accessToken, refreshToken, menuList, authList } = res.data.data
      localStorage.setItem('menuList', JSON.stringify(menuList))
      localStorage.setItem('authList', JSON.stringify(authList))
      app.authList = authList
      app.menuList = menuList
      setToken(accessToken)
      setRefreshToken(refreshToken)
      const data = jwtDecode<UserState>(accessToken)
      user.$patch(data)
      localStorage.setItem('userInfo', JSON.stringify(data))
      Sentry.setUser({ username: data.name, id: data.id + '', email: user.mail })
      Notification.success({
        title: '刷新成功',
        content: '已更新您的权限数据以及菜单数据为最新状态！',
        closable: true
      })
    } else {
      console.warn(res.data.errorMsg)
    }
  }).catch(err => {
    console.log(err)
    throw new Error(err)
  })
}

const drawerVisible = ref(false)

return (_ctx: any,_cache: any) => {
  const _component_icon_menu = _resolveComponent("icon-menu")!
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_icon_sun_fill = _resolveComponent("icon-sun-fill")!
  const _component_icon_moon_fill = _resolveComponent("icon-moon-fill")!
  const _component_icon_check = _resolveComponent("icon-check")!
  const _component_a_doption = _resolveComponent("a-doption")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_icon_translate = _resolveComponent("icon-translate")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_icon_code_square = _resolveComponent("icon-code-square")!
  const _component_icon_down = _resolveComponent("icon-down")!
  const _component_icon_settings = _resolveComponent("icon-settings")!
  const _component_icon_export = _resolveComponent("icon-export")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_a_drawer = _resolveComponent("a-drawer")!
  const _directive_perm = _resolveDirective("perm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_layout_header, { class: "header-section" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_a_space, null, {
            default: _withCtx(() => [
              _createVNode(_component_icon_menu, {
                class: "menu-switch",
                size: "24",
                style: {"color":"rgba(var(--gray-8))"},
                onClick: _cache[0] || (_cache[0] = ($event: any) => (drawerVisible.value = true))
              }),
              _createElementVNode("img", {
                alt: "logo",
                src: _imports_0,
                style: {"height":"30px"},
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/')))
              }),
              _createVNode(_component_a_typography_title, {
                style: { margin: 0, fontSize: '18px' },
                heading: 5,
                class: "title",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 巨商汇工作台 ")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("ul", _hoisted_2, [
          (canInstall.value)
            ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
                _createVNode(_component_a_button, {
                  type: "primary",
                  shape: "round",
                  onClick: installApp
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" install ")
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("li", _hoisted_4, [
            _createVNode(_component_a_dropdown, { trigger: "hover" }, {
              content: _withCtx(() => [
                _createVNode(_component_a_doption, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_space, {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (changeTheme('light')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_icon_check, {
                          style: _normalizeStyle({
                    opacity: +(themeModel.value === 'light')
                  })
                        }, null, 8, ["style"]),
                        _hoisted_5
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_doption, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_space, {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (changeTheme('dark')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_icon_check, {
                          style: _normalizeStyle({
                    opacity: +(themeModel.value === 'dark')
                  })
                        }, null, 8, ["style"]),
                        _hoisted_6
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_doption, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_space, {
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (changeTheme('auto')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_icon_check, {
                          style: _normalizeStyle({
                    opacity: +(themeModel.value === 'auto')
                  })
                        }, null, 8, ["style"]),
                        _hoisted_7
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "text",
                  shape: 'circle',
                  style: {"color":"rgba(var(--gray-8))"},
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (changeTheme()))
                }, {
                  icon: _withCtx(() => [
                    (!_unref(isDark))
                      ? (_openBlock(), _createBlock(_component_icon_sun_fill, {
                          key: 0,
                          size: "18"
                        }))
                      : (_openBlock(), _createBlock(_component_icon_moon_fill, {
                          key: 1,
                          size: "18"
                        }))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_a_tooltip, { content: "刷新账号权限" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "text",
                  shape: 'circle',
                  style: {"color":"rgba(var(--gray-8))"},
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (updateAuth()))
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_icon_translate, { size: "18" })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _withDirectives((_openBlock(), _createElementBlock("li", null, [
            _createVNode(_component_a_tooltip, { content: "WebShell" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "text",
                  shape: 'circle',
                  style: {"color":"rgba(var(--gray-8))"},
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$router.push('/shell-console')))
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_icon_code_square, { size: "18" })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])), [
            [
              _directive_perm,
              void 0,
              void 0,
              { "layout-shell-console": true }
            ]
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_a_dropdown, { trigger: "hover" }, {
              content: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_a_doption, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_space, {
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$router.push({ name: 'ConfigCenter' })))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_icon_settings),
                        _hoisted_9
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })), [
                  [
                    _directive_perm,
                    void 0,
                    void 0,
                    { "config-center-view": true }
                  ]
                ]),
                _createVNode(_component_a_doption, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_space, { onClick: _unref(logout) }, {
                      default: _withCtx(() => [
                        _createVNode(_component_icon_export),
                        _hoisted_10
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_8, [
                  _createTextVNode(_toDisplayString(_unref(user).name) + " ", 1),
                  _createVNode(_component_icon_down)
                ])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_a_drawer, {
      class: "sidebar-drawer",
      visible: drawerVisible.value,
      placement: "left",
      "unmount-on-close": "",
      closable: false,
      "mask-closable": "",
      header: false,
      footer: false,
      onCancel: _cache[11] || (_cache[11] = ($event: any) => (drawerVisible.value=false))
    }, {
      default: _withCtx(() => [
        _createVNode(Menu, {
          onPush: _cache[10] || (_cache[10] = ($event: any) => (drawerVisible.value=false))
        })
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_button, {
      class: "change-theme-btn-mobile",
      type: "outline",
      shape: 'circle',
      style: {"color":"rgba(var(--gray-8))"},
      onClick: _cache[12] || (_cache[12] = ($event: any) => (changeTheme()))
    }, {
      icon: _withCtx(() => [
        (!_unref(isDark))
          ? (_openBlock(), _createBlock(_component_icon_sun_fill, {
              key: 0,
              size: "18"
            }))
          : (_openBlock(), _createBlock(_component_icon_moon_fill, {
              key: 1,
              size: "18"
            }))
      ]),
      _: 1
    })
  ], 64))
}
}

})